/**
 * @file useUpStep 上一步
 */
import { useUpdate } from '@tencent/glue-react-use';
import { useCallback, useEffect } from 'react';
import { usePoint } from './usePoint';
export function useUpStep(part, type) {
  var update = useUpdate();
  var point = usePoint(part);
  var value = point.getPrecisionValue(type);

  var _point$getAxis$getAxi = point.getAxis(type).getAxisConfig(),
      step = _point$getAxis$getAxi.step,
      max = _point$getAxis$getAxi.max;

  useEffect(function () {
    point.addListener('repaint', update);
    return function () {
      return point.removeListener('repaint', update);
    };
  }, [point]);
  var handler = useCallback(function (stepCount) {
    point.upStep(type, stepCount);
  }, [point]);
  return [+value + step > max, handler];
}